import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../i18n';

/**
 * Hook to get the current language from URL or i18next
 * Returns the language code (e.g., 'en', 'de', 'fr', etc.)
 */
export function useCurrentLang(): string {
  const { lang } = useParams<{ lang?: string }>();
  const { i18n } = useTranslation();

  // Try to get language from URL first
  if (lang && SUPPORTED_LANGUAGES.includes(lang as any)) {
    return lang;
  }

  // Fallback to i18next language or default
  return i18n.language || DEFAULT_LANGUAGE;
}

/**
 * Hook to get a localized path with the current language prefix
 * @param path - The path without language prefix (e.g., '/bunker')
 * @returns Full path with language prefix (e.g., '/en/bunker')
 */
export function useLocalizedPath() {
  const lang = useCurrentLang();

  return (path: string) => {
    // Remove leading slash if present and add language prefix
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${lang}/${cleanPath}`;
  };
}
